/**
 * KLG Quotes API
 *
 * Contact: xxx@kaplan.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CourseDatesInfoApiDto } from './course-dates-info.model';

export interface PriceRequestFiltersResponseApiDto {
  durationMin?: number;
  durationMax?: number;
  startDates?: CourseDatesInfoApiDto;
  accommodations?: Array<PriceRequestFiltersResponseApiDto.AccommodationsEnum>;
}
export namespace PriceRequestFiltersResponseApiDto {
  export const AccommodationsEnum = {
    FAMILY_STAY: 'FAMILY_STAY',
    RESIDENCE: 'RESIDENCE',
    SHARED_APARTMENT: 'SHARED_APARTMENT',
    CAMPUS: 'CAMPUS',
    WITHOUT_ACCOMMODATION: 'WITHOUT_ACCOMMODATION',
  } as const;
  export type AccommodationsEnum = (typeof AccommodationsEnum)[keyof typeof AccommodationsEnum];
}
